<div>
  <a routerLink="/dashboard" (click)="onClick()">
    <bdo-svg name="icon-arrow-left" styling="position-left"></bdo-svg>
    <span class="bold">{{ 'general.navigation.backToStart' | translate }}</span>
  </a>
</div>
